
import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
} from "@/components/ui/sidebar";
import { SidebarMenuItem } from "./SidebarMenuItem";

interface AppSidebarMenuProps {
  orderedMenuItems: any[];
  expandedItems: string[];
  showIcons: boolean;
  isCollapsed: boolean;
  toggleExpanded: (title: string) => void;
  isActive: (href: string) => boolean;
  isParentActive: (item: any) => boolean;
}

export function AppSidebarMenu({
  orderedMenuItems,
  expandedItems,
  showIcons,
  isCollapsed,
  toggleExpanded,
  isActive,
  isParentActive
}: AppSidebarMenuProps) {

  return (
    <SidebarContent className={`flex-1 overflow-y-auto custom-scrollbar ${isCollapsed ? 'px-2 py-3' : 'p-4'}`}>
      <SidebarGroup>
        <SidebarGroupContent>
          <SidebarMenu className={`space-y-1 ${isCollapsed ? 'items-center' : ''}`}>
            {orderedMenuItems.map((item, index) => (
              <div key={item.title} className="fade-in-up" style={{ animationDelay: `${index * 0.03}s` }}>
                <SidebarMenuItem
                  item={item}
                  isCollapsed={isCollapsed}
                  showIcons={showIcons}
                  expandedItems={expandedItems}
                  toggleExpanded={toggleExpanded}
                  isActive={isActive}
                  isParentActive={isParentActive}
                />
              </div>
            ))}
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarContent>
  );
}
